export default __webpack_public_path__ + "static/media/smash.595202ae.mp3";